import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Copy from '../../../assets/copy.svg';
import Loading from '../../../assets/loading.gif';
import {QRCodeSVG} from 'qrcode.react';
import { getStrLang } from '../../Translate';
import 'jquery-ui-dist/jquery-ui';
import { getAvailableCrypto, getCrypto, getDeposit } from '../../../api/fastcoinService';
import toast, { Toaster } from 'react-hot-toast';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';
import {MenuItem,Select,FormControl,InputLabel} from "@material-ui/core";
import $ from 'jquery';
import Timer from '../../Timer';

let timeoutId2 = null;

const Crypto = (props) => {
    const crypto_avaliable = true
    //Chamada para as variáveis e funções do Context
    const { translate, lang } = useLanguage();
    //Traduz o texto na tela quando mudado o idioma pelo usuário
    const [coinList, setCoinList] = useState(sessionStorage.getItem("coinList") !== null ? JSON.parse(sessionStorage.getItem("coinList")) : [])
    const [selected_coin, setSelectedCoin] = useState("")
    const [loadingCryptoInfo, setLoadingCryptoInfo] = useState(false);
    const [infoCrypto, setInfoCrypto] = useState(sessionStorage.getItem("crypto_info") !== null ? JSON.parse(sessionStorage.getItem("crypto_info")) : undefined);
    const [expirado, setExpirado] = useState(false);
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [showQr, setShowQr] = useState(false)
    const [timeoutTime,setTimeoutTime]=useState(1000000)
    const [client_logo,set_client_logo]=useState('')

    useEffect(() => {
        translate();
    }, [translate]);

    useEffect(() => {
        if(infoCrypto!==undefined){
            setTimeoutTime(infoCrypto?.timeout/60)
            setInfoCrypto(infoCrypto);
            setShowQr(true) 
            const coin=sessionStorage.getItem("selected_coin")
            if(coin){
                setSelectedCoin(coin)
            }
        }else{
            if(props.isUsdtPixPayment!==true){
                getAvailableCrypto(props.provider)
                .then(res => {
                    setCoinList(res)
                    setSelectedCoin(res[0])
                    sessionStorage.setItem("coinList", JSON.stringify(res));
                })
                .catch(err => {
                    console.log(err.toString());
                });
            }else{
                if(props.provider==="crypto_now"){
                    setCoinList(["USDTTRC20"])
                    setSelectedCoin("USDTTRC20")
                }else if(props.provider==="cryptopayx"){
                    setCoinList(["USDT.TRON"])
                    setSelectedCoin("USDT.TRON")
                }else{
                    setCoinList(["USDT.TRC20"])
                    setSelectedCoin("USDT.TRC20")
                }
            }
            
        }
        const logoData=sessionStorage.getItem('client_logo')
        if(logoData){
            set_client_logo(logoData)
        }else{
            if(sessionStorage.getItem('is_white_label') === "true"){
            }else{
                set_client_logo('favicon.ico')
            }
        }
    }, [])


    const callCrypto = (e) => {
        e.preventDefault();
        setLoadingCryptoInfo(true);
        let isUsdtPixPayment=props.isUsdtPixPayment?true:false
        getCrypto(sessionStorage.getItem("order_no"), selected_coin,isUsdtPixPayment,props.provider)
            .then(res => {
                if (res !== undefined) {
                    setTimeoutTime(res.timeout/60)
                    setInfoCrypto(res);
                    sessionStorage.setItem("crypto_info", JSON.stringify(res));
                    sessionStorage.setItem("selected_coin", selected_coin);
                    setWaitingPayment(true);
                    setShowQr(true) 
                    sessionStorage.setItem("date_crypto", new Date());
                    setLoadingCryptoInfo(false)
                } else {
                    setInfoCrypto({ error: "Please, talk with the Administrator." });
                }
            })
            .catch(err => {
                console.log(err.response)
                toast.error(err.response?.data || err.toString());
            }).finally(() => {
                setLoadingCryptoInfo(false);
                translate();
            });
    }

    useEffect(() => {
        function doEffect() {
            let ctrl = $("#message-crypto span");
            $(ctrl).css("display", "flex");
            $(ctrl).fadeIn(500, function () {
                ctrl.effect("pulsate", 15000).fadeOut(500);
                doEffect(ctrl);
            });
        }
        function checkPayment() {
            console.log('checkPayment crypto')
            timeoutId2 = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            doEffect();
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
        return () => {
            if (timeoutId2) {
                clearTimeout(timeoutId2);
                console.log('timeoutId2 cleared');
                timeoutId2=null;
            }
        };
    }, [showQr]);

    const notify2 = () => {
        navigator.clipboard.writeText(infoCrypto?.amount);
        toast.success(getStrLang(lang.nameLang, "notify_toast"));
    }
    const notify = () => {
        navigator.clipboard.writeText(infoCrypto?.address);
        toast.success(getStrLang(lang.nameLang, "notify_toast"));
    }
    const changeCoin=()=>{
        setShowQr(false)
        setInfoCrypto(null)
    }

    useEffect(()=>{
        if(timeoutTime!==1000000 && expirado===true){
            changeCoin()
        }
    },[expirado])
    return (
        <>
            <Toaster
                toastOptions={{
                    className: '',
                    style: {
                        border: '1px solid #0d4fb8',
                        color: '#0d4fb8',
                        padding: '12px',
                        top: '300px',
                        //  position: 'relative',
                    },
                }}
            />
            {loadingCryptoInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}

            {!showQr && !loadingCryptoInfo &&
                <div className="row">
                    <div className='col-md-12 d-flex justify-content-center'>
                        <form onSubmit={callCrypto}>
                            <br /><br />
                            <div className="form-group">
                                {/* <label htmlFor="coin">{getStrLang(lang.nameLang, "coin_select")}</label> */}
                                <FormControl sx={{ m: 1,minWidth: 600 }}>
                                    <InputLabel id="coin-label">{getStrLang(lang.nameLang, "coin_select")}</InputLabel>
                                    <Select
                                        labelId="coin-label"
                                        id="coin"
                                        value={selected_coin}
                                        onChange={(e) => {
                                            setSelectedCoin(e.target.value);
                                        }}
                                        label="coin"
                                        style={{width:"300px"}}
                                    >
                                        {coinList.length > 0 && coinList.map((coin) => {
                                            let coin_name = coin.split(".")[0]
                                            const imageUrl = props.provider==="crypto_now" ?`https://nowpayments.io/images/coins/${coin_name.toLowerCase()}.svg`: `https://www.coinpayments.net/images/coins/${coin_name}.png`;
                                            return <MenuItem value={coin}>
                                                <img
                                                    src={imageUrl}
                                                    width={20}
                                                    height={20}
                                                    style={{marginRight:"5px"}}
                                                />
                                                {coin}
                                            </MenuItem>;
                                        })}
                                    </Select>
                                </FormControl>
                                {/* <select
                                    className="form-control"
                                    id="coin"
                                    value={selected_coin}
                                    onChange={(e) => {
                                        setSelectedCoin(e.target.value);
                                    }}
                                    style={{ width: "300px" }}
                                >
                                    {coinList.length > 0 && coinList.map((coin) => {
                                        let coin_name=coin.split(".")[0]
                                        const imageUrl = `https://www.coinpayments.net/images/coins/${coin_name}.png`;
                                        console.log(imageUrl)
                                        return <option value={coin} key={coin}>
                                               <img src={imageUrl} alt="" /> {coin}
                                            </option>;
                                    })}
                                </select> */}
                            </div>
                            <button type='submit' className='btn btn-primary'>{getStrLang(lang.nameLang, "generate_wallet")}</button>
                        </form>
                    </div>
                </div>
            }

            {showQr &&
                <div className="group-pix-content">
                    <div className="infoarea-pix">
                        {timeoutTime!==1000000 && <Timer countdown={timeoutTime} setExpirado={setExpirado} crypto={true}/>}
                        
                        <div id='message-crypto' className='infoarea-crypto-message'>
                                <span>{getStrLang(lang.nameLang, "waiting-payment-crypto")}</span>
                        </div>
                        <div className="form-pix-header">
                            {/*<img id="image-logo-tabs" src={Logo} alt={"Logo"} style={{width: "50%"}} /> */}
                        </div>
                    </div>
                    <div className="pix-container">
                        {!expirado &&
                            <div className="grup-crypto-opt">
                                <div className="msg-pix">
                                    {!loadingCryptoInfo &&<>
                                    <div>
                                        <button  className="btn btn-primary" onClick={changeCoin}>{getStrLang(lang.nameLang, "change_coin")}</button>
                                    </div>
                                    <br />
                                    <div>
                                        <img style={{float:"left"}} src={props.provider==="crypto_now" ?`https://nowpayments.io/images/coins/${selected_coin.toLowerCase()}.svg`:`https://www.coinpayments.net/images/coins/${selected_coin.split(".")[0]}.png`} alt={selected_coin} width="40px" height="40px" />
                                    </div>
                                    </>}

                                    {crypto_avaliable ?
                                        <>
                                            {infoCrypto !== undefined && infoCrypto?.address !== undefined ?
                                                <>
                                                
                                                    
                                                    <br />
                                                    <QRCodeSVG value={infoCrypto?.address} size={180} imageSettings={{src:client_logo,height:40,width:40}}/>

                                                    
                                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                                        <div className="form-group form-inputs">
                                                            <label htmlFor={"crypto_info"} data-lang-str={props.data_lang_label} className="bold_text_ted"></label>
                                                            <div className="input-line-pix">
                                                                <input type="text" id={"crypto_info"} className="form-control form-control-lg" value={infoCrypto.address} />
                                                                <div className="copy-area-pix" onClick={() => notify()} data-balloon-visible aria-label={getStrLang(lang.nameLang, "copy_crypto_address")} data-balloon-pos="down">
                                                                    <img src={Copy} alt="Copy" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                                        <div className="form-group form-inputs">
                                                            <label htmlFor={"crypto_info"} data-lang-str={props.data_lang_label} className="bold_text_ted"></label>
                                                            <div className="input-line-pix">
                                                                <input type="text" id={"crypto_info"} className="form-control form-control-lg" value={infoCrypto.amount+" "+selected_coin} />
                                                                <div className="copy-area-pix" onClick={() => notify2()} data-balloon-visible aria-label={getStrLang(lang.nameLang, "copy_crypto_amount")} data-balloon-pos="down">
                                                                    <img src={Copy} alt="Copy" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    {loadingCryptoInfo && <img src={Loading} alt={"loading"} width="30px" height="30px" />}
                                                </>
                                            }
                                            {/* <h4 className="div-info-pag" data-lang-str="information_pix"></h4>*/}
                                        </>
                                        :
                                        <h4 data-lang-str="information_pix"></h4>
                                    }

                                </div>
                            
                            </div>

                        }
                    </div>
                    {expirado ?
                        <>
                            <p className="center footer_pix"><b>{getStrLang(lang.nameLang, "payment_expiration")}</b></p>
                        </>
                        :
                        <>
                            <p className="center footer_pix"><b>{getStrLang(lang.nameLang, "crypto_amount_txt")}</b></p>
                        </>
                    }
                </div>
            }

        </>

    )
}

export default Crypto;